import {setTimeout} from "timers";
<template>
  <div>
    <v-layout justify-center>
      <v-flex xs12>
        <v-stepper :value="currentStep" class="stepperClass">
          <v-stepper-header>
            <v-stepper-step step="1"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3"></v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('ENGAGEMENT_CAMPAIGN')}}</h3>
    </v-layout>
    <div>
      <div v-if="step1">
        <v-layout justify-center>
          <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('FIRST_PROMOTION')}}</h3>
        </v-layout>
        <v-flex xs12>
          <v-checkbox color="primary" label="Use first promotion" v-model="disable1"></v-checkbox>
        <v-form ref="firstForm" v-model="form1Valid">
          <v-layout row justify-space-between>
          <v-flex xs5>
          <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('WHOM')}}</h3>
          <h4 class="mt-2">{{$translate('SELECTION_OF_USERS')}}</h4>
          <v-select
            outline
            :disabled="!disable1"
            v-model="form[0].ToEventSubscribers"
            :items="messageCriteriaOptions"
            item-text="criteriaName"
            item-value="criteriaId"
          ></v-select>
          <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('WHAT')}}</h3>
            <h4 class="mt-2">{{$translate('MESSAGE_CATEGORY')}}</h4>
            <v-select
              :items="availableTags"
              item-text="name"
              outline
              return-object
              v-model="form[0].tags"
              :label="$translate('SELECT_MESSAGE_CATEGORY')">
            </v-select>
          <v-textarea
            rows="1"
            auto-grow
            :label="$translate('TITLE_MESSAGE')"
            :disabled="!disable1"
            v-model="form[0].Title"
            :counter="50"
            :rules="emtpyStringRule"
            outline
            ref="eventForm"
          />
          <v-textarea
            rows="1"
            auto-grow
            :label="$translate('TEXT_MESSAGE')"
            :disabled="!disable1"
            multiple
            v-model="form[0].Text"
            :rules="emtpyStringRule"
            :counter="1024"
            outline
            ref="eventForm"
          />
          <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('WHEN')}}</h3>
          <v-layout wrap>
            <v-flex xs12 md6 class="paddingRight">
              <v-menu
                :disabled="!disable1"
                ref="menu1"
                :close-on-content-click="true"
                v-model="menu1"
                :nudge-right="40"
                :return-value.sync="form[0].date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  :disabled="!disable1"
                  clearable
                  slot="activator"
                  v-model="form[0].date"
                  :label="$translate('DATE')"
                  class
                  outline
                  hide-details
                  :rules="emtpyStringRule"
                  append-icon="event"
                  readonly
                  ref="eventForm"
                ></v-text-field>
                <v-date-picker
                  :disabled="!disable1"
                  first-day-of-week="1"
                  color="primary"
                  v-model="form[0].date"
                  @input="$refs.menu1.save(form[0].date)"
                  no-title
                  scrollable
                />
              </v-menu>
            </v-flex>
            <v-flex xs12 md6 class="paddingLeft">
              <v-text-field
                :disabled="!disable1"
                v-model="form[0].time"
                :label="$translate('TIME')"
                outline
                hint="Input: hh:mm"
                :rules="emtpyStringRule"
                append-icon="access_time"
                ref="eventForm"
                mask="time"
                type="time"
              ></v-text-field>
            </v-flex>
            <!-- <v-flex xs12 md6 class="paddingRight">
              <h4 class="mt-2">Campaign budget</h4>
              <v-select
                outline
                :disabled="!disable1"
                v-model="form[0].budget"
                :items="campaignBudget"
                item-text="amountName"
                item-value="amount"
              ></v-select>
            </v-flex> -->
          </v-layout>
          </v-flex>
          <v-flex xs6>
            <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('EVENT_PIC_SHORT')}}</h3>
            <h4 class="mt-2">{{$translate('EVENT_MESSAGE_PICTURE')}}</h4>
            <image-loader
              :properties="form[0].imageProperties"
              v-on:load_image="setImageElement()"
            ></image-loader>
            <h3 v-if="orderEventActive" :style="`color: ${$vuetify.theme.primary}`">{{$translate('EVENT_MESSAGE_PRODUCT_OPT')}}</h3>
            <h4 v-if="orderEventActive" class="mt-2">{{$translate('EVENT_MESSAGE_PRODUCT')}}</h4>
            <v-select
              v-if="orderEventActive"
              :items="products"
              item-text="Name"
              item-value="Id"
              outline
              v-model="form[0].selectedProduct"
              :label="$translate('EVENT_MESSAGE_SELECT_PRODUCT')">
            </v-select>
          </v-flex>
          </v-layout>
        </v-form>
        </v-flex>
      </div>
      <div v-if="step2">
        <v-layout justify-center>
          <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('SECOND_PROMOTION')}}</h3>
        </v-layout>
        <v-flex xs12>
        <v-checkbox color="primary" label="Use second promotion" v-model="disable2"></v-checkbox>
        <v-form ref="secondForm" v-model="form2Valid">
          <v-layout row justify-space-between>
            <v-flex xs5>
          <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('WHOM')}}</h3>
          <h4 class="mt-2">{{$translate('SELECTION_OF_USERS')}}</h4>
          <v-select
            outline
            :disabled="!disable2"
            v-model="form[1].ToEventSubscribers"
            :items="messageCriteriaOptions"
            item-text="criteriaName"
            item-value="criteriaId"
          ></v-select>
          <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('WHAT')}}</h3>
              <h4 class="mt-2">{{$translate('MESSAGE_CATEGORY')}}</h4>
              <v-select
                :items="availableTags"
                item-text="name"
                outline
                return-object
                v-model="form[1].tags"
                :label="$translate('SELECT_MESSAGE_CATEGORY')">
              </v-select>
          <v-textarea
            rows="1"
            auto-grow
            :label="$translate('TITLE_MESSAGE')"
            :disabled="!disable2"
            v-model="form[1].Title"
            :rules="emtpyStringRule"
            :counter="50"
            outline
            ref="eventForm"
          />
          <v-textarea
            rows="1"
            auto-grow
            :label="$translate('TEXT_MESSAGE')"
            :disabled="!disable2"
            multiple
            v-model="form[1].Text"
            :rules="emtpyStringRule"
            :counter="140"
            outline
            ref="eventForm"
          />
          <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('WHEN')}}</h3>
          <v-layout wrap>
            <v-flex xs12 md6 class="paddingRight">
              <v-menu
                :disabled="!disable2"
                ref="menu1"
                :close-on-content-click="true"
                v-model="menu1"
                :nudge-right="40"
                :return-value.sync="form[1].date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  :disabled="!disable2"
                  clearable
                  slot="activator"
                  v-model="form[1].date"
                  class
                  :label="$translate('DATE')"
                  outline
                  hide-details
                  :rules="emtpyStringRule"
                  append-icon="event"
                  readonly
                  ref="eventForm"
                ></v-text-field>
                <v-date-picker
                  :disabled="!disable2"
                  first-day-of-week="1"
                  color="primary"
                  v-model="form[1].date"
                  @input="$refs.menu1.save(form[1].date)"
                  no-title
                  scrollable
                />
              </v-menu>
            </v-flex>
            <v-flex xs12 md6 class="paddingLeft">
              <v-text-field
                :disabled="!disable2"
                v-model="form[1].time"
                class
                :label="$translate('TIME')"
                outline
                :rules="emtpyStringRule"
                hint="Input: hh:mm"
                append-icon="access_time"
                ref="eventForm"
                mask="time"
                type="time"
              ></v-text-field>
            </v-flex>
            <!-- <v-flex xs12 md6 class="paddingRight">
              <h4 class="mt-2">Campaign budget</h4>
              <v-select
                outline
                :disabled="!disable2"
                v-model="form[1].budget"
                :items="campaignBudget"
                item-text="amountName"
                item-value="amount"
              ></v-select>
            </v-flex> -->
          </v-layout>
            </v-flex>
            <v-flex xs6>
              <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('EVENT_PIC_SHORT')}}</h3>
              <h4 class="mt-2">{{$translate('EVENT_MESSAGE_PICTURE')}}</h4>
              <image-loader
                :properties="form[1].imageProperties"
                v-on:load_image="setImageElement()"
              ></image-loader>
              <h3 v-if="orderEventActive" :style="`color: ${$vuetify.theme.primary}`">{{$translate('EVENT_MESSAGE_PRODUCT_OPT')}}</h3>
              <h4 v-if="orderEventActive" class="mt-2">{{$translate('EVENT_MESSAGE_PRODUCT')}}</h4>
              <v-select
                v-if="orderEventActive"
                :items="products"
                item-text="Name"
                item-value="Id"
                outline
                v-model="form[1].selectedProduct"
                :label="$translate('EVENT_MESSAGE_SELECT_PRODUCT')">
              </v-select>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
      </div>
      <div v-if="step3">
        <v-layout justify-center>
          <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('CATERING_PROMOTION')}}</h3>
        </v-layout>
        <v-flex xs12>
          <v-checkbox color="primary" label="Use catering promotion" v-model="disable3"></v-checkbox>
          <v-form ref="thirdForm" v-model="form3Valid">
            <v-layout row justify-space-between>
              <v-flex xs5>
                <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('WHOM')}}</h3>
                <h4 class="mt-2">{{$translate('SELECTION_OF_USERS')}}</h4>
                <v-select
                  outline
                  :disabled="!disable3"
                  v-model="form[2].ToEventSubscribers"
                  :items="messageCriteriaOptions"
                  item-text="criteriaName"
                  item-value="criteriaId"
                ></v-select>
                <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('WHAT')}}</h3>
                <h4 class="mt-2">{{$translate('MESSAGE_CATEGORY')}}</h4>
                <v-select
                  :items="availableTags"
                  item-text="name"
                  outline
                  return-object
                  v-model="form[2].tags"
                  :label="$translate('SELECT_MESSAGE_CATEGORY')">
                </v-select>
                <v-textarea
                  rows="1"
                  auto-grow
                  :label="$translate('TITLE_MESSAGE')"
                  :disabled="!disable3"
                  v-model="form[2].Title"
                  :rules="emtpyStringRule"
                  :counter="50"
                  outline
                  ref="eventForm"
                />
                <v-textarea
                  rows="1"
                  auto-grow
                  :label="$translate('TEXT_MESSAGE')"
                  :disabled="!disable3"
                  multiple
                  v-model="form[2].Text"
                  :rules="emtpyStringRule"
                  :counter="140"
                  outline
                  ref="eventForm"
                />
                <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('WHEN')}}</h3>
                <v-layout wrap>
                  <v-flex xs12 md6 class="paddingRight">
                    <v-menu
                      :disabled="!disable3"
                      ref="menu1"
                      :close-on-content-click="true"
                      v-model="menu1"
                      :nudge-right="40"
                      :return-value.sync="form[2].date"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        :disabled="!disable3"
                        clearable
                        slot="activator"
                        v-model="form[2].date"
                        class
                        :label="$translate('DATE')"
                        outline
                        hide-details
                        :rules="emtpyStringRule"
                        append-icon="event"
                        readonly
                        ref="eventForm"
                      ></v-text-field>
                      <v-date-picker
                        :disabled="!disable3"
                        first-day-of-week="1"
                        color="primary"
                        v-model="form[2].date"
                        @input="$refs.menu1.save(form[2].date)"
                        no-title
                        scrollable
                      />
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 md6 class="paddingLeft">
                    <v-text-field
                      :disabled="!disable3"
                      v-model="form[2].time"
                      class
                      :label="$translate('TIME')"
                      outline
                      :rules="emtpyStringRule"
                      hint="Input: hh:mm"
                      append-icon="access_time"
                      ref="eventForm"
                      mask="time"
                      type="time"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('EVENT_PIC_SHIRT')}}</h3>
                <h4 class="mt-2">{{$translate('EVENT_MESSAGE_PICTURE')}}</h4>
                <image-loader
                  :properties="form[2].imageProperties"
                  v-on:load_image="setImageElement()"
                ></image-loader>
                <h3 v-if="orderEventActive" :style="`color: ${$vuetify.theme.primary}`">{{$translate('EVENT_MESSAGE_PRODUCT_OPT')}}</h3>
                <h4 v-if="orderEventActive" class="mt-2">{{$translate('EVENT_MESSAGE_PRODUCT')}}</h4>
                <v-select
                  v-if="orderEventActive"
                  :items="products"
                  item-text="Name"
                  item-value="Id"
                  outline
                  v-model="form[2].selectedProduct"
                  :label="$translate('EVENT_MESSAGE_SELECT_PRODUCT')">
                </v-select>
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
      </div>
      <v-layout row class="mt-4">
        <v-flex xs5>
          <v-btn
            round
            color="secondary"
            class="dialogButton text-capitalize"
            @click="back"
          >{{prevString}}</v-btn>
        </v-flex>
        <v-flex xs2 />
        <v-flex xs5>
          <v-btn
            round
            v-if="!step3"
            color="primary"
            class="dialogButton text-capitalize"
            @click="nextOption"
          >{{nextString}}</v-btn>
          <v-btn
            round
            v-if="step3"
            color="primary"
            class="dialogButton text-capitalize"
            @click="nextOption"
          >{{$translate('CONFIRM')}}</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { map_functions } from "../shared/map_functions.js";
import { mapGetters } from "vuex";
import * as dssRequest from "../api/dssRequest";
import BaseObject from "../objects/BaseObject";
import appConfig from "../../config/app_config";
import CommunicationCenterObject from "../objects/CommunicationCenterObject";
import BaseComponent from "./base/BaseComponent.vue";
import ExpendableTags from "@/components/ExpendableTags";
import ImageLoader from "@/components/media/ImageLoader";


export default {
  extends: BaseComponent,
  name: "EngagementCampaign",
  components: {
    ExpendableTags,
    ImageLoader
  },
  props: {
    eventData: {}
  },
  computed: {
    ...mapGetters({
      tags: "getAllTags"
    })
  },
  created() {

    setTimeout(() => {
      this.getProducts();
      this.setTags();
    }, 250);
  },
  data() {
    return {

      products: [],
      orderEventActive: false,
      messageCriteriaOptions: [
        { criteriaId: 0, criteriaName: this.$translate("CRITERIA_BOTH") },
        { criteriaId: 1, criteriaName: this.$translate("CRITERIA_REG") },
        { criteriaId: 2, criteriaName: this.$translate("CRITERIA_NOT_REG") }
      ],
      campaignBudget: [
        { amount: 25, amountName: "25 euro" },
        { amount: 50, amountName: "50 euro" },
        { amount: 75, amountName: "75 euro" },
        { amount: 100, amountName: "100 euro" },
        { amount: 200, amountName: "200 euro" }
      ],
      availableTags: [],
      preselection: [],
      prevString: this.$translate("BACK"),
      nextString: "Go to 2nd promotion",
      form1Valid: false,
      form2Valid: false,
      form3Valid: false,
      emtpyStringRule: [
        v => !!v || "Field is required",
        v => v != 0 || "Field must at least be 1 char long!"
      ],
      step1: true,
      step2: false,
      step3: false,
      disable1: false,
      disable2: false,
      disable3: false,
      prop1: {
        // disable: false
      },
      menu1: false,
      menu2: false,
      // promotionCode: ["3XWRY", "5TBON", "8JTIO", "9PUTI"],
      currentStep: "1",
      form: [
        {
          Title: "",
          Text: "",
          PromoCode: "",
          tags: [],
          time: "",
          date: "",
          selectedProduct: '',
          imageProperties: {
            title: "Message Picture",
            signalName: "load_image",
            deletable: false,
            pictureUrl: "",
            maxWidth: appConfig.maxSize.home.w,
            maxHeight: appConfig.maxSize.home.h,
            scale: "w"
          },
          ToEventSubscribers: null,
          budget: 0
        },
        {
          Title: "",
          imageProperties: {
            title: "Message Picture",
            signalName: "load_image",
            deletable: false,
            pictureUrl: "",
            maxWidth: appConfig.maxSize.home.w,
            maxHeight: appConfig.maxSize.home.h,
            scale: "w"
          },
          Text: "",
          PromoCode: "",
          tags: [],
          time: "",
          date: "",
          selectedProduct: '',
          ToEventSubscribers: null,
          budget: 0
        },
        {
          Title: "",
          imageProperties: {
            title: "Message Picture",
            signalName: "load_image",
            deletable: false,
            pictureUrl: "",
            maxWidth: appConfig.maxSize.home.w,
            maxHeight: appConfig.maxSize.home.h,
            scale: "w"
          },
          Text: "",
          PromoCode: "",
          tags: [],
          time: "",
          date: "",
          selectedProduct: '',
          ToEventSubscribers: null,
          budget: 0
        }
      ]
    };
  },
  methods: {
    setTags() {
      let usableTags = [];
      this.$store.getters.getFilterTags.forEach( e => {
        if (e.title === 'MessageCategory') {
          e.entries.forEach( a => {
            usableTags.push({id: a.k, name: a.v, group: a.group})
          })
        }
      });
      this.availableTags = [];
      this.availableTags = usableTags;
    },
    getProducts(){

      if (this.eventData.type !== 'OrderEvent' && this.eventData.type !== 'Rental') {
        return;
      }
      this.orderEventActive = true;
      const payload = {
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getProducts was successful",
            response
          );
          for (let [index, item] of Object.entries(response.data.Products)){
            this.products.push({Id: item.Id, Name: item.Name })
          }
        },
        error => {
          console.log(
            "The generic call getProducts was not successful",
            error
          );
        },
        "getProducts",
        this.eventData.eventId,
        payload
      );
    },
    setImageElement(e) {
      if (e.signalName == this.form[this.currentStep - 1].imageProperties.signalName) {
        this.form[this.currentStep - 1].imageProperties.pictureUrl = e.url;
      }
    },
    nextOption() {
      if (
        this.disable1 != false ||
        this.disable2 != false ||
        this.disable3 != false
      ) {
        if (
          (this.form[this.currentStep - 1].time != "" &&
            this.form[this.currentStep - 1].time.length != 4) ||
          (this.form[this.currentStep - 1].time != "" &&
            this.form[this.currentStep - 1].time.charAt(0) > "2")
        ) {
          window.EventBus.fire("inputDialog");
          return null;
        }

        if (
          this.form[this.currentStep - 1].time != "" &&
          (this.form[this.currentStep - 1].time.charAt(2) == "6" ||
            this.form[this.currentStep - 1].time.charAt(2) == "7" ||
            this.form[this.currentStep - 1].time.charAt(2) == "8" ||
            this.form[this.currentStep - 1].time.charAt(2) == "9" ||
            this.form[this.currentStep - 1].time.length > 5)
        ) {
          window.EventBus.fire("inputDialog");
          return null;
        }
        if (this.form[this.currentStep - 1].time.charAt(2) !== ":") {
          this.form[this.currentStep - 1].time =
            this.form[this.currentStep - 1].time.slice(0, 2) +
            ":" +
            this.form[this.currentStep - 1].time.slice(2, 4);
        }
      }
      this.next();
    },
    next() {
      if (this.$refs.firstForm != undefined)
        this.$refs.firstForm.resetValidation();
      if (this.$refs.secondForm != undefined)
        this.$refs.secondForm.resetValidation();
      if (this.$refs.thirdForm != undefined)
        this.$refs.thirdForm.resetValidation();
      if (this.step3 == true) {
        if (this.disable3) {
          if (!this.$refs.thirdForm.validate()) {
            return;
          }
          this.saveMessage();
        } else this.closeMessageScreen();
        //TODO store campaign message
      }
      if (this.step2 == true) {
        if (this.disable2) {
          if (!this.$refs.secondForm.validate()) {
            return;
          }
          this.saveMessage();
        } else {
          this.currentStep++;
          this.preselection = this.form[this.currentStep - 1].tags;
        }
        this.prevString = "Back to 2nd promotion";
        this.nextString = "Go to step 3";
        this.step2 = false;
        this.step3 = true;
      }
      if (this.step1 == true) {
        if (this.disable1) {
          if (!this.$refs.firstForm.validate()) {
            return;
          }
          this.saveMessage();
        } else {
          this.currentStep++;

          this.preselection = this.form[this.currentStep - 1].tags;
        }
        this.prevString = "Back to 1st promotion";
        this.nextString = "Go to Catering promotion";
        // this.currentStep = "2";
        this.step1 = false;
        this.step2 = true;
      }
    },
    back() {
      if (this.$refs.firstForm != undefined)
        this.$refs.firstForm.resetValidation();
      if (this.$refs.secondForm != undefined)
        this.$refs.secondForm.resetValidation();
      if (this.$refs.thirdForm != undefined)
        this.$refs.thirdForm.resetValidation();

      if (this.step1 == true) {
        this.backToMessageDialog();
      }
      if (this.step2 == true) {
        this.prevString = this.$translate("BACK");
        this.nextString = "Go to 2nd promotion";
        this.currentStep = "1";
        this.step1 = true;
        this.step2 = false;

        // if (this.form[this.currentStep - 1].UnitId !== undefined)
        //   this.getMessageTags(this.form[this.currentStep - 1].UnitId);
        // for (let [k, v] of Object.entries(
        //   this.form[this.currentStep - 1].tags
        // )) {
        //   for (let k1 of Object.keys(v)) {
        //     this.preselection.push(k1);
        //   }
        // }
      }
      if (this.step3 == true) {
        this.prevString = "Back to 1st promotion";
        this.nextString = "Go to Catering promotion";
        this.currentStep = "2";
        this.step3 = false;
        this.step2 = true;
        // this.preselection = this.form[this.currentStep - 1].tags;
        // if (this.form[this.currentStep - 1].UnitId !== undefined)
        //   this.getMessageTags(this.form[this.currentStep - 1].UnitId);
      }
    },

    getMessageTags(unitId) {
      const payload = {
        RelationType: "Message",
        Id: unitId,
        Types: {
          User: "User"
        },
        FunctionId: "TagsFunctionLibrary::getTagRelations",
        PartnerId: this.$store.getters['auth/partnerId']
      };
      this.preselection = [];
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getTagRelations(getTags) was successful",
            response
          );
          let tags = BaseObject._createArrayWithObjects(response.data.Tags);
          tags = tags.filter(e => e.Description !== "Temporary Administrator");
          for (let [k, v] of Object.entries(tags)) {
            if (v.Selected == "yes") {
              this.preselection.push(v);
            }
          }
        },
        error => {
          console.log(
            "The generic call getTagRelations(getTags) was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        this.currentAccountId + "_CMR",
        payload
      );
    },
    saveMessage() {
      this.form[this.currentStep - 1].picture = this.form[this.currentStep - 1].imageProperties.pictureUrl;
      let payload = CommunicationCenterObject._saveSingleMessageForEngagementCampaignObject(
        this.form[this.currentStep - 1],
        appConfig.dss.environmentName,
        this.eventData
      );

      if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        payload.PartnerId = -1;
      } else {
        payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
      }

      payload.FunctionId = "MessageFunctionLibrary::saveMessage";
      dssRequest.doRequest(
        response => {
          console.log("The generic call saveMessage was successful", response);
          this.form[this.currentStep - 1].UnitId = response.data.UnitId;
          window.EventBus.fire(
            "activateSnackBar",
            "Message saved successfully !"
          );
          if (this.currentStep == 3) this.closeMessageScreen();
          this.preselection = [];
          this.currentStep++;
        },
        error => {
          console.log(
            "The generic call saveMessage was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        this.currentAccountId + "_CMR",
        payload
      );
    },
    backToMessageDialog() {
      // this.$emit("closeDialog", true);
      this.$emit("backButton", {});
    },
    closeMessageScreen() {
      this.$emit("closeDialog", true);
    }
  }
};
</script>


<style scoped>
.scrollable {
  overflow-x: hidden;
  overflow-y: hidden;
}
.marginTop {
  margin-top: 100px !important;
}

.dialogButton {
  width: 100% !important;
  margin: 0px 0px 25px 0px;
}

.itemBorder {
  border-bottom: solid black 1px;
}

.boxStyle {
  max-height: 175px;
  overflow-y: auto;
  overflow-x: hidden;
}

.stepperClass {
  box-shadow: none;
}

@media only screen and (min-width: 960px) {
  .paddingLeft {
    padding-left: 25px;
  }
  .paddingRight {
    padding-right: 25px;
  }
}
</style>
